import { makeStyles } from "@material-ui/core";

export const useStyles = makeStyles((theme) => ({
  dialogPaper: {
    borderRadius: 16,
    padding: theme.spacing(1),
  },
  header: {
    display: "flex",
    alignItems: "center",
    gap: theme.spacing(1.5),
    padding: theme.spacing(2, 2.5, 1),
  },
  headerIcon: {
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    width: 40,
    height: 40,
    borderRadius: 10,
    backgroundColor: "#fdecea",
    color: "#d32f2f",
    flexShrink: 0,
  },
  title: {
    fontSize: "1rem",
    fontWeight: 700,
    color: "#1f2937",
  },
  subtitle: {
    fontSize: "0.78rem",
    color: "#6b7280",
  },
  content: {
    padding: theme.spacing(1, 2.5, 2),
  },
  warning: {
    fontSize: "0.8rem",
    color: "#6b7280",
    marginBottom: theme.spacing(2),
    lineHeight: 1.5,
  },
  field: {
    marginBottom: theme.spacing(2),
  },
  notifyNote: {
    display: "flex",
    alignItems: "flex-start",
    gap: theme.spacing(1),
    padding: theme.spacing(1.25, 1.5),
    borderRadius: 10,
    backgroundColor: "#f8fafc",
    border: "1px solid #eef0f3",
    fontSize: "0.76rem",
    color: "#4b5563",
    lineHeight: 1.5,
  },
  notifyIcon: {
    fontSize: 16,
    color: "#0a8f54",
    flexShrink: 0,
    marginTop: 2,
  },
  actions: {
    padding: theme.spacing(1, 2.5, 2),
    gap: theme.spacing(1),
  },
  keepBtn: {
    textTransform: "none",
    fontWeight: 600,
  },
  confirmBtn: {
    textTransform: "none",
    fontWeight: 600,
    backgroundColor: "#d32f2f",
    color: "#ffffff",
    "&:hover": {
      backgroundColor: "#b71c1c",
    },
    "&.Mui-disabled": {
      backgroundColor: "#e5e7eb",
      color: "#9ca3af",
    },
  },
}));
